<form autocomplete="off" (ngSubmit)="buscar()">
  <input
    type="text"
    name="termino"
    class="form-control animate__animated animate__zoomIn"
    [placeholder]="textPlaceHolder"
    [(ngModel)]="termino"
    (input)="teclaPresionada()"
  />
</form>
